import { actionEqual } from './utils';
import * as ActionCreators from '../actions/ActionCreators';

const getDefaultStep4Data = () => {
  return {
    dataItem: {
      items: [],
      type: 'dataItem',
    },
    shopItem: {
      items: [],
      type: 'shopItem',
    },
    shopItemCategory: {
      items: [],
      type: 'shopItemCategory',
    },
  };
};

const defaultState: DataInterestFormState = {
  id: undefined,
  step: 1,
  step2Data: [],
  step2TagsSelected: [],
  shouldFetchStep3Data: true,
  step3Data: [],
  step3TagsSelected: [],
  step4TagsSelected: getDefaultStep4Data(),
  title: '',
  designation: '',
  dialCode: '',
  fullName: '',
  phoneNumber: '',
  email: '',
  company: '',
  step1Cache: {
    title: '',
    designation: '',
    dialCode: '',
    fullName: '',
    phoneNumber: '',
    email: '',
    company: '',
  },
  shouldShowRequestSubmittedPopup: false,
};

export default function dataInterestForm(
  state: DataInterestFormState = defaultState,
  action: Action
): DataInterestFormState {
  if (actionEqual(action, ActionCreators.setStep)) {
    const { step } = action.payload;
    return {
      ...state,
      step,
    };
  } else if (actionEqual(action, ActionCreators.setStep2Data)) {
    return {
      ...state,
      step2Data: action.payload.data,
    };
  } else if (actionEqual(action, ActionCreators.setStep3Data)) {
    return {
      ...state,
      step3Data: action.payload.data,
      shouldFetchStep3Data: false,
      step3TagsSelected: [],
      step4TagsSelected: getDefaultStep4Data(),
    };
  } else if (actionEqual(action, ActionCreators.setStep2TagSelected)) {
    const tag = action.payload.tag;
    if (!state.step2TagsSelected.includes(tag)) {
      state.step2TagsSelected.push(action.payload.tag);
    } else {
      state.step2TagsSelected = state.step2TagsSelected.filter(t => t !== tag);
    }
    return {
      ...state,
      step2TagsSelected: state.step2TagsSelected,
      shouldFetchStep3Data: true,
      step3Data: [],
      step3TagsSelected: [],
      step4TagsSelected: getDefaultStep4Data(),
    };
  } else if (actionEqual(action, ActionCreators.setStep3TagSelected)) {
    const tag = action.payload.tag;
    if (!state.step3TagsSelected.includes(tag)) {
      state.step3TagsSelected.push(tag);
    } else {
      state.step3TagsSelected = state.step3TagsSelected.filter(t => t !== tag);
    }
    return {
      ...state,
      step3TagsSelected: state.step3TagsSelected,
      step4TagsSelected: getDefaultStep4Data(),
    };
  } else if (actionEqual(action, ActionCreators.setStep4TagSelected)) {
    const { item, type } = action.payload;

    switch (type) {
      case 'dataItem':
        const dataItem = item as DataItem;
        if (!state.step4TagsSelected.dataItem.items.includes(dataItem)) {
          state.step4TagsSelected.dataItem.items.push(dataItem);
        } else {
          state.step4TagsSelected.dataItem.items = state.step4TagsSelected.dataItem.items.filter(
            itemObj => itemObj !== item
          );
        }
        break;
      case 'shopItem':
        const shopItem = item as ShopItem;
        if (!state.step4TagsSelected.shopItem.items.includes(shopItem)) {
          state.step4TagsSelected.shopItem.items.push(shopItem);
        } else {
          state.step4TagsSelected.shopItem.items = state.step4TagsSelected.shopItem.items.filter(
            itemObj => itemObj !== item
          );
        }
        break;
      case 'shopItemCategory':
        const shopItemCategory = item as ShopItemCategory;
        if (
          !state.step4TagsSelected.shopItemCategory.items.includes(
            shopItemCategory
          )
        ) {
          state.step4TagsSelected.shopItemCategory.items.push(shopItemCategory);
        } else {
          state.step4TagsSelected.shopItemCategory.items = state.step4TagsSelected.shopItemCategory.items.filter(
            itemObj => itemObj !== item
          );
        }
        break;
    }
    return {
      ...state,
      step4TagsSelected: state.step4TagsSelected,
    };
  } else if (actionEqual(action, ActionCreators.setTitle)) {
    return {
      ...state,
      title: action.payload.title,
    };
  } else if (actionEqual(action, ActionCreators.setDesignation)) {
    return {
      ...state,
      designation: action.payload.designation,
    };
  } else if (actionEqual(action, ActionCreators.setDialCode)) {
    return {
      ...state,
      dialCode: action.payload.dialCode,
    };
  } else if (actionEqual(action, ActionCreators.setFullName)) {
    return {
      ...state,
      fullName: action.payload.fullName,
    };
  } else if (actionEqual(action, ActionCreators.setPhoneNumber)) {
    return {
      ...state,
      phoneNumber: action.payload.phoneNumber,
    };
  } else if (actionEqual(action, ActionCreators.setEmail)) {
    return {
      ...state,
      email: action.payload.email,
    };
  } else if (actionEqual(action, ActionCreators.setCompany)) {
    return {
      ...state,
      company: action.payload.company,
    };
  } else if (actionEqual(action, ActionCreators.setStep1Cache)) {
    const {
      title,
      designation,
      fullName,
      dialCode,
      phoneNumber,
      email,
      company,
    } = state;
    return {
      ...state,
      step1Cache: {
        title,
        designation,
        dialCode,
        fullName,
        phoneNumber,
        email,
        company,
      },
    };
  } else if (
    actionEqual(action, ActionCreators.setShouldShowRequestSubmittedPopup)
  ) {
    return {
      ...state,
      shouldShowRequestSubmittedPopup: true,
    };
  } else {
    return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/dataInterestForm.ts